export const environment = {
  production: false,
  mock: false,
  realm: 'DecisionSpace_Integration_Server',
  authServerUrl: 'https://pae.kc.ienergycloud.solutions/auth',
  resource: 'dho-frontend',
  viewLogout: true,
  urlBackend: 'https://pae.dho.ienergycloud.solutions',
  executiveResumeEnabled: true,
};
